import { useState } from "react";

import { t } from "../../lib/i18n";

import { Button } from "./Button";
import { CopyButton } from "./CopyButton";

import "./ui.css";

interface JsonViewerProps {
  value: unknown;
  /** Initial collapsed state. */
  defaultCollapsed?: boolean;
  /** Max characters to render when collapsed (best-effort). */
  collapsedLimit?: number;
}

export function JsonViewer({
  value,
  defaultCollapsed = false,
  collapsedLimit = 600,
}: JsonViewerProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const formatted = JSON.stringify(value, null, 2);
  const shown =
    collapsed && formatted.length > collapsedLimit
      ? `${formatted.slice(0, collapsedLimit)}\n…`
      : formatted;

  return (
    <div className="json-viewer">
      <div className="json-viewer__actions">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setCollapsed((v) => !v)}
        >
          {collapsed ? t("common.expand") : t("common.collapse")}
        </Button>
        <CopyButton value={formatted} />
      </div>
      <pre className="json-viewer__pre">{shown}</pre>
    </div>
  );
}
